export default "__VITE_ASSET__CUxZG6RS__"